import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';

import { useRouter } from '@boss/hooks';
import { InspirationOverviewFields } from '@boss/types/b2b-b2c';
import { InspirationGrid, Section } from '@boss/ui';

import { ComponentMapper, getInspirationImageProps } from '../components';

type Props = { page: InspirationOverviewFields; locale: string };

const InspirationOverviewPage = ({ page, locale }: Props) => {
  const { t } = useTranslation('inspiration');

  const router = useRouter();
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (!router.isReady || hasInitialized) {
      return;
    }

    setHasInitialized(true);

    const { filt, val } = router.query;

    if (!filt || !val || typeof val !== 'string' || typeof filt !== 'string') {
      return;
    }

    router.replace(
      {
        pathname: router.pathname,
        query: { filter: `${filt}:"${val}"` },
      },
      undefined,
      { shallow: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, hasInitialized]);

  return (
    <div className="w-full">
      {page.prefixSections?.length &&
        page.prefixSections.map(entry => <ComponentMapper entry={entry} key={entry.id} locale={locale} theme={null} />)}
      <Section content={<InspirationGrid {...getInspirationImageProps(null, locale, t)} />} />
      {page.suffixSections?.length &&
        page.suffixSections.map(entry => <ComponentMapper entry={entry} key={entry.id} locale={locale} theme={null} />)}
    </div>
  );
};

export default InspirationOverviewPage;
